/*
 * Copyright (C) 2026 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { Component } from '@angular/core';
import { InvitationJoinComponent } from '../invitation-join/invitation-join.component';

@Component({
  selector: 'ptl-v3-invitation-join',
  templateUrl: './v3-invitation-join.component.html',
  styleUrls: ['./v3-invitation-join.component.scss'],
})
export class V3InvitationJoinComponent extends InvitationJoinComponent {}
